import type { ExperimentName } from '../config'

import { useExperiments } from './useExperiments'

/**
 * Retrieve the value of an experiment, falling back to a default value when
 * no variation has been assigned (i.e. the experiment resolves to
 * `noVariation`).
 *
 * @example
 * const pageName = useExperimentValue('experiment.homeCMSPageName', { defaultValue: 'home' })
 */
export function useExperimentValue(
  experimentName: ExperimentName,
  { defaultValue }: { defaultValue: string },
): string {
  const variation = useExperiments()[experimentName]

  if (!variation || variation === 'noVariation') return defaultValue

  return variation
}
